import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { IMultiStoreSelect } from 'src/app/common/models/multiStoreSelect';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { AdminUIHelpers } from 'src/app/common/helpers';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MultiStoreDropdown } from '../../multi-store-dropdown/multi-store-dropdown.component';
import { MatButton } from '@angular/material/button';

export interface IMultiStoreDialogData {
  multiStoreData: IMultiStoreSelect[];
  edits?: string[];
}

@Component({
  selector: 'multi-store-select',
  templateUrl: './multi-store.component.html',
  styleUrls: ['./multi-store.component.scss'],
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, MultiStoreDropdown, MatButton, MatDialogClose],
})
export class MultiStoreComponent implements OnInit {
  @Output() public outputFacilitiesEvent? = new EventEmitter<IMultiStoreSelect[]>();
  public scrollCalled = false;
  public facilities: IMultiStoreSelect[] = [];
  public currentFacility: string;
  public edits: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<MultiStoreComponent>,
    private _facilityManager: FacilityManager,
    @Inject(MAT_DIALOG_DATA) public dialogInput: IMultiStoreDialogData,
  ) {
    this.currentFacility = this._facilityManager.getCurrentFacility();
  }

  public ngOnInit(): void {
    this.edits = this.dialogInput.edits || [];
    if (this.dialogInput.multiStoreData.length < 1) {
      const facilityArray = AdminUIHelpers.getFacilitiesForMultiStore(this._facilityManager.prepFacilities());
      for (const facility of facilityArray) {
        facility.isSelected = facility.facilityId === this._facilityManager.getCurrentFacility() ? true : false;
        this.facilities.push(facility);
      }
    } else {
      this.facilities = JSON.parse(JSON.stringify(this.dialogInput.multiStoreData)) as IMultiStoreSelect[];
    }
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
